import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["title", "difficulty", "description", "techStack", "checklistContainer", "template", "generateBtn", "difficultySelect"]

    connect() {
        // 既存のデータがない場合、空の入力欄を1つ作っておくなどの初期化
        if (this.checklistContainerTarget.children.length === 0) {
            this.add()
        }
    }

    add(e) {
        if (e) e.preventDefault()

        const content = this.templateTarget.innerHTML
        this.checklistContainerTarget.insertAdjacentHTML('beforeend', content)
    }

    removeField(e) {
        e.preventDefault()
        const wrapper = e.target.closest('.nested-form-wrapper')
        if (wrapper) {
            wrapper.remove()
        }
    }

    async generate(e) {
        e.preventDefault()

        const difficulty = this.difficultySelectTarget.value

        // UI Loading State
        const originalText = this.generateBtnTarget.innerHTML
        this.generateBtnTarget.disabled = true
        this.generateBtnTarget.innerHTML = `
      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      AIが思考中...🍋
    `

        try {
            const response = await fetch("/admin/project_ideas/generate", {
                method: "POST",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ difficulty: difficulty })
            })

            const json = await response.json()

            if (json.success) {
                this.populateForm(json.data)
            } else {
                alert(json.message || "生成に失敗しました")
            }

        } catch (error) {
            console.error(error)
            alert("通信エラーが発生しました")
        } finally {
            this.generateBtnTarget.disabled = false
            this.generateBtnTarget.innerHTML = originalText
        }
    }

    populateForm(data) {
        if (this.hasTitleTarget) this.titleTarget.value = data.title
        if (this.hasDescriptionTarget) this.descriptionTarget.value = data.description
        if (this.hasDifficultyTarget) this.difficultyTarget.value = data.difficulty
        if (this.hasTechStackTarget) this.techStackTarget.value = data.tech_stack

        // Checklist
        if (data.checklist && Array.isArray(data.checklist)) {
            // Clear existing
            this.checklistContainerTarget.innerHTML = ""

            data.checklist.forEach(step => {
                // templateの内容をコピーして挿入
                const tempDiv = document.createElement('div')
                tempDiv.innerHTML = this.templateTarget.innerHTML

                const wrapper = tempDiv.firstElementChild

                // 値をセット
                const inputs = wrapper.querySelectorAll('input, textarea')
                // 0: task, 1: description (順番依存なので注意。name属性などで探す方が安全だが簡易実装)

                // name="project_idea[checklist][][task]" のinputを探す
                const taskInput = wrapper.querySelector('input[name*="[task]"]')
                const descInput = wrapper.querySelector('textarea[name*="[description]"]')

                if (taskInput) taskInput.value = step.task
                if (descInput) descInput.value = step.description

                this.checklistContainerTarget.appendChild(wrapper)
            })
        }
    }
}
